import MobileHeader from "../../../../../../../../layout/mobile-header";
import * as S from "../../styles";
import { useControllerContext } from "../../../../../../hooks/controller-context";
import { ControllerTab } from "../../../../../../hooks/use-controller-tab";
import { usePointPaid } from "../../../../../../../solution/components/point-paid/hook/usePointPaid";
import { TournamentType } from "../../../../../../../tournament/hook/useEditTournament";
import { useMemo } from "react";
import MobileTimerControllerPrizeItem from "./prize-item";
import SearchMemberPopup from "../../../../../../../solution/components/point-paid/components/search-member";

const MobileTimerControllerPrize = () => {
  const { setControllerTab, data } = useControllerContext();

  const hook = usePointPaid({
    tournamentId: data?.id ?? 0,
    getData: () => {},
  });
  const {
    allPrizeList,
    setAllPrizeList,
    totalSeedAmount, // 시상 가능 시드 전체
    totalPointAmount, // 시상 가능 매장 이용권 전체
    isSearch,
    setIsSearch,
    selectRank,
    setLocalStorage,
  } = hook;
  const isGtd = data?.tournamentType === TournamentType.Tournament;
  const minSeed = Math.round(totalSeedAmount * 0.9);
  const maxSeed = Math.round(totalSeedAmount * 1.1);
  // 시상 총 시드 (데일리)
  const totalSeed = useMemo(() => {
    return allPrizeList.reduce(
      (acc, curr) => (acc += curr.payMent ? curr.totalPrize : 0),
      0,
    );
  }, [allPrizeList]);

  // 시상 가능 매장이용권 (GTD)
  const totalPoint = useMemo(() => {
    const sumPointPrize = allPrizeList.reduce(
      (acc, curr) => (acc += curr?.pointPrize || 0),
      0,
    );
    return totalPointAmount - sumPointPrize;
  }, [totalPointAmount, allPrizeList]);

  // 팝업 닫을 때 핸들러
  const handleClose = () => {
    if (!data) return;

    // 전체 등수 시상 완료 됐을 시 로컬에서 삭제
    if (!allPrizeList.some((item) => !item.payMent)) {
      localStorage.removeItem(`tournament_${data.id}`);
    } else {
      // 로컬에 현재 내용 저장
      setLocalStorage(allPrizeList);
    }
    setControllerTab(ControllerTab.TOURNAMENT);
  };

  return (
    <S.MobileControllerPrizeWrapper $hasBottomBar={false}>
      {isSearch && (
        <SearchMemberPopup
          prizeList={allPrizeList}
          setPrizeList={setAllPrizeList}
          index={selectRank === null ? -1 : selectRank}
          onClose={() => setIsSearch(false)}
          tournamentId={data?.id ?? 0}
        />
      )}
      <MobileHeader title="시상" back={handleClose} />
      <S.MobileControllerPrizeInfoWrapper>
        <div className="box red">
          <img src="/image-web/controller/m-warning.svg" alt="warning" />
          {isGtd
            ? "GTD 토너먼트의 경우 프라이즈 합산의 30% 이내로 매장이용권 시상이 가능"
            : "토탈프라이즈의 +-10% 범위 내에서 시상이 가능합니다."}
        </div>
        <div className="box">
          <div className="wrapper">
            <div className="name">
              {isGtd ? "시상 가능 총 매장이용권" : "시상 가능 총 프라이즈 범위"}
            </div>
            <div className="value">
              {isGtd
                ? `${totalPoint.toLocaleString()}E`
                : `${minSeed.toLocaleString()}RB ~ ${maxSeed.toLocaleString()}RB`}
            </div>
          </div>
          {!isGtd && (
            <div className="wrapper">
              <div className="name">
                <img src="/image-web/controller/m-prize-pay.svg" alt="pay" />
                시상 완료
              </div>
              <div className="value">{totalSeed.toLocaleString()}</div>
            </div>
          )}
        </div>
      </S.MobileControllerPrizeInfoWrapper>

      <S.MobileControllerPrizeListWrapper>
        {allPrizeList.map((item, index) => (
          <MobileTimerControllerPrizeItem
            hook={hook}
            isGtd={isGtd}
            item={item}
            index={index}
            key={index}
          />
        ))}
      </S.MobileControllerPrizeListWrapper>
    </S.MobileControllerPrizeWrapper>
  );
};

export default MobileTimerControllerPrize;
